import { Link } from 'react-router-dom';
import Container from 'components/Container';
import ResponsiveImage from 'components/ResponsiveImage';
import { ArrowRightIcon } from 'components/icons';

/** Full-bleed photograph with the brand story on a card over its lower edge. */
export default function StoryBlock({ block }) {
  const id = `blk-${block.id}`;
  return (
    <section aria-labelledby={id} className="relative pb-6 lg:pb-0">
      <div className="relative h-[380px] overflow-hidden bg-surface-alt sm:h-[460px] lg:h-[640px]">
        <ResponsiveImage
          image={block.image}
          sizes="100vw"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
      <Container className="relative -mt-24 lg:absolute lg:inset-x-0 lg:bottom-14 lg:mt-0">
        <div className="max-w-[30rem] rounded bg-background p-7 sm:p-10">
          {block.eyebrow && <p className="eyebrow mb-4">{block.eyebrow}</p>}
          <h2 id={id} className="font-display text-[1.9rem] leading-[1.1] text-ink sm:text-[2.4rem]">
            {block.title}
          </h2>
          <p className="mt-4 text-pretty text-muted">{block.body}</p>
          {block.link && (
            <Link
              to={block.link.href}
              className="group mt-6 inline-flex min-h-[44px] items-center gap-2 text-[15px] font-semibold text-ink underline-offset-4 hover:underline"
            >
              {block.link.label}
              <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
          )}
        </div>
      </Container>
    </section>
  );
}
